import { render } from "./CategoryIcon.vue?vue&type=template&id=d5f1edee&ts=true"
import script from "./CategoryIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/CategoryIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5f1edee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5f1edee', __exports__)) {
    api.reload('d5f1edee', __exports__)
  }
  
  module.hot.accept("./CategoryIcon.vue?vue&type=template&id=d5f1edee&ts=true", () => {
    api.rerender('d5f1edee', render)
  })

}


export default __exports__